document.addEventListener('alpine:init', () => {
  Alpine.data('CustomVariantsForm', () => ({
    product: null,
    selected_licenses: {
      desktop: [],
      web: [],
      other: []
    },
    selected_styles: [],
    selected_variants: [],
    all_styles: [],
    init() {
      this.InitWatchers();
      this.InitSelf();
    },

    InitWatchers() {
      // only 1 web license at a time
      this.$watch('selected_licenses.web', (web_licenses) => {
        if (web_licenses.length > 1) {
          let recently_selected = web_licenses[web_licenses.length - 1];
          this.selected_licenses.web = [...[recently_selected]];
        }
      });

      // If "Complete Family" is selected, remove other styles
      this.$watch('selected_styles', (selected_styles) => {
        if (!this.product.option_style) return;
        let styles = [];

        let style_complete_family = this.product.option_style.values[0];
        let recently_selected = selected_styles[selected_styles.length - 1];

        if (recently_selected == style_complete_family) {
          styles = [...[style_complete_family]];
        }
        else {
          styles = [...this.selected_styles.filter(style => style !== style_complete_family)];
        }

        if (styles.join(',') === this.selected_styles.join(',')) {
          return; // No change, do nothing
        }

        this.selected_styles = styles;
      });

      // Update variants based on current selections
      this.$watch('selected_licenses', this.SetVariants.bind(this));
      this.$watch('selected_styles', this.SetVariants.bind(this));
    },

    InitSelf() {
      let product = JSON.parse(this.$el.dataset.product);
      let options_with_values = JSON.parse(this.$el.dataset.options_with_values);
      let option_license = options_with_values.find(option => option.name.includes('License'));
      let option_style = options_with_values.find(option => option.name.includes('Style'));
      product.options_with_values = options_with_values;
      product.option_license = option_license;
      product.option_style = option_style;
      this.product = product;
      this.all_styles = this.$el.dataset.all_styles.replace(', ', ',').split(',');
      console.log(this.all_styles);

      this.PreSelections();
    },

    PreSelections() {
      // preselect Desktop license if available
      let license_option = this.product.option_license;
      if (license_option.values.some(value => value.includes('Desktop'))) {
        this.selected_licenses.desktop = [license_option.values.find(value => value.includes('Desktop'))];
      }

      // preselect "Style" if configured
      if (this.product.option_style) {
        let style_option = this.product.option_style;
        if (style_option.values.some(value => this.all_styles.includes(value))) {
          this.selected_styles = [style_option.values.find(value => this.all_styles.includes(value))];
        }
      }
    },

    SetVariants() {
      let selected_variants = [];
      let selected_licenses = [
        ...this.selected_licenses.desktop,
        ...this.selected_licenses.web,
        ...this.selected_licenses.other
      ];
      let selected_styles = [...this.selected_styles];
      // If no style option is available, use a placeholder
      if (!this.product.option_style) {
        selected_styles = [''];
      }
      // console.log({selected_licenses, selected_styles})

      selected_licenses.forEach(license => {
        selected_styles.forEach(style => {
          let variant = this.product.variants.find(v => 
            v.title.includes(license) && v.title.includes(style)
          );
          if (variant) {
            selected_variants = [...selected_variants, variant];
          }
        });
      });
      this.selected_variants = [...selected_variants];
    },

    u_GetTotal() {
      return this.selected_variants.reduce((total, variant) => {
        return total + variant.price;
      }, 0);
    },

    u_FormatMoney(value) {
      return FoxTheme.Currency.formatMoney(value);
    },

    e_ResetForm() {
      this.selected_licenses = {
        desktop: [],
        web: [],
        other: []
      };
      this.selected_styles = [];
      this.selected_variants = [];

      this.PreSelections();
    },

    async e_AddToCart() {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const config = FoxTheme.utils.fetchConfig('javascript');
      config.headers['Content-Type'] = 'application/json';

      const sections_url = window.location.pathname;

      config.body = JSON.stringify({
        items: this.selected_variants.map(variant => ({
          id: variant.id,
          quantity: 1,
        })),
        sections: sectionsToBundle,
        sections_url: sections_url
      });

      let res_json = await fetch(`${FoxTheme.routes.cart_add_url}`, config)
        .then((response) => response.json());

      const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
      cartJson['sections'] = res_json['sections'];

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

      // If any quickview modal is open, close them
      document.querySelectorAll('quick-view-modal[open] .drawer__close-btn').forEach((btn) => {
        btn.click();
      });

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { open: true }
      }));
    }
  }));
});